import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICharges } from '@core/models/modals';
import { MbDialogHeader, MbDialogBody, MB_DIALOG_DATA } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-modal-charges',
  standalone: true,
  imports: [CommonModule, MbDialogHeader, MbDialogBody, SharedModule],
  templateUrl: './charges.component.html',
  styleUrls: ['./charges.component.scss'],
})
export class ModalChargesComponent extends DialogWrapperComponent implements OnInit {
  public emptyStateImage: string;
  constructor(@Inject(MB_DIALOG_DATA) public dialogData: ICharges) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.emptyStateImage = `hotels/dist/es-AR/browser/assets/images/no-charges.svg`;
  }
}
